import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    labels: Array,
    counts: Array,
  };

  connect() {
    if (typeof ApexCharts === "undefined") {
      this.element.innerHTML =
        '<p class="text-warning small mb-0">Biblioteca de gráficos não carregada.</p>';
      return;
    }

    const labels = this.labelsValue || [];
    const counts = this.countsValue || [];

    this.chart = new ApexCharts(this.element, this.buildOptions(labels, counts));
    this.chart.render();
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }

  buildOptions(labels, counts) {
    const primary =
      typeof getComputedStyle !== "undefined"
        ? getComputedStyle(document.documentElement).getPropertyValue("--bs-primary").trim() ||
          "#696cff"
        : "#696cff";

    return {
      chart: {
        type: "bar",
        height: 320,
        toolbar: { show: false },
        fontFamily: "inherit",
        parentHeightOffset: 0,
      },
      series: [{ name: "Processos", data: counts }],
      xaxis: {
        categories: labels,
        labels: {
          rotate: -35,
          rotateAlways: labels.length > 8,
          hideOverlappingLabels: true,
        },
      },
      colors: [primary],
      plotOptions: {
        bar: {
          borderRadius: 6,
          columnWidth: "62%",
          dataLabels: { position: "top" },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -18,
        style: { fontSize: "11px", fontWeight: 600 },
        formatter: (val) => (Number(val) > 0 ? val : ""),
      },
      yaxis: {
        min: 0,
        forceNiceScale: true,
        labels: {
          formatter: (v) => (Number.isFinite(v) ? Math.round(v) : v),
        },
      },
      grid: {
        borderColor: "rgba(var(--bs-body-color-rgb), 0.08)",
        strokeDashArray: 4,
      },
      tooltip: {
        y: {
          formatter: (val) => {
            const n = Number(val);
            return `${n} ${n === 1 ? "processo" : "processos"}`;
          },
        },
      },
    };
  }
}
